import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../styles/materialButtonStyle";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../elements/filter/styledFiter";
import MappedServicesFilter from "../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import ClientsSelect from "../../elements/clients/ClientsSelect";

const WalletMainWhitelistFilter = ({ filterData, setFilterData }) => {
  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "user.id": null,
    "user.email": null,
    "currency": null,
    "paymentSystem": null,
    "wallet": "",
  };

  const { t } = useTranslation("walletWhitelistPage");

  const [visible, setVisible] = useState(false);
  const [checkedUser, setCheckedUser] = useState(filterData["user.email"] ?? null);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
    setCheckedUser(null);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }));
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <MappedServicesFilter
                checkedPaymentSystem={filterData["paymentSystem"]}
                setCheckedPaymentSystem={data => handleChangeFilterData(data, "paymentSystem")}

                checkedCurrency={filterData["currency"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "currency")}
              />
              <StyledFilterGroup>
                <label htmlFor="wallet">
                  {t("filter.wallet")}
                </label>
                <DelayInput
                  id="wallet"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "wallet": event.target.value, page: 1 })}
                  name="asset"
                  value={filterData["wallet"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("filter.byUser")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <label htmlFor="userId">
                  {t("filter.userId")}
                </label>
                <DelayInput
                  id="userId"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "user.id": event.target.value, page: 1 })}
                  name="user.id"
                  value={filterData["user.id"]}
                  type="text"
                />
              </StyledFilterGroup>

              <ClientsSelect
                label={t("filter.userEmail")}
                checkedUser={checkedUser}
                setCheckedUser={(user) => {
                  setCheckedUser(user);
                  setFilterData({
                    ...filterData,
                    "user.email": user || null,
                    page: 1
                  });
                }}
              />

            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default WalletMainWhitelistFilter;